import React, { useState } from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Button from "common/components/CustomButtons/Button.jsx";

import Table from "common/components/Table/Table.jsx";

// @material-ui/core components
import Assignment from "@material-ui/icons/Assignment";

// import loadContent from "core-module/hoc/loadContent";
import loadForm from "core-module/hoc/loadForm";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

import * as api from "core-module/services/api";
import store from "../../store";
import { showAlert } from "../../core-module/services/errorAlert/reducers";

const importedStyle = dashboardStyle;

const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  stats: importedStyle.stats,
  right: {
    textAlign: "right",
  },
};

const AccountInfoCard = (props) => {
  const { classes } = props;
  const [showButton, setButtonState] = useState(true);

  const accountName =
    props.getData("name2") != null && props.getData("name2").length > 0
      ? props.getData("name") + " (" + props.getData("name2") + " )"
      : props.getData("name");

  const tableData = [
    ["Name", accountName],
    ["Address", props.getData("address")],
    ["Postal Code", props.getData("postalcode")],
    ["City", props.getData("city")],
    [
      "Province",
      Number(props.getData("regionid")) === 1
        ? "AB"
        : Number(props.getData("regionid")) === 2
        ? "SK"
        : "-",
    ],
  ];

  const phoneTableData = [];
  const phoneNumbers = props.getData("phonenumbers");
  if (phoneNumbers.length === 0) {
    phoneTableData.push(["None", ""]);
  } else {
    for (let pn of phoneNumbers) {
      phoneTableData.push([pn.description, pn.phoneno]);
    }
  }

  const emailTableData = [];
  const emailAddresses = props.getData("emailaddresses");
  if (emailAddresses.length === 0) {
    emailTableData.push(["None", ""]);
  } else {
    for (let ea of emailAddresses) {
      emailTableData.push([ea.email, ""]);
    }
  }

  async function modeSelection() {
    const target = "user." + props.ids.user + "/accountinfoupdate";
    try {
      const res = await api.fetchApi(`?target=${target}&schema=f`, "GET", "");
      const resDataArray = JSON.parse(await res.text());

      if (resDataArray.error == 1) {
        store.dispatch(showAlert("Please try again"));
      }
      setButtonState(resDataArray.zeroRows);
    } catch (e) {
      store.dispatch(showAlert(e.message));
    }
  }

  modeSelection();

  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Account info</h4>
      </CardHeader>
      <CardBody>
        <GridContainer justify="center">
          <GridItem>
            {showButton ? (
              <Button color="primaryLightBlue" onClick={() => props.editMode()}>
                Request Account Info Change
              </Button>
            ) : (
              "Your request is under review."
            )}
          </GridItem>
          <GridItem xs={11}>
            <br />
            <br />
            <Table
              customCellClasses={[classes.right]}
              customClassesForCells={[1]}
              tableData={tableData}
            />
          </GridItem>
          <GridItem xs={11}>
            <br />
            <h4 className={classes.cardTitle}>Phone Numbers</h4>
            <br />
          </GridItem>
          <GridItem xs={11}>
            <Table
              customCellClasses={[classes.right]}
              customClassesForCells={[1]}
              tableData={phoneTableData}
            />
          </GridItem>
          <GridItem xs={11}>
            <br />
            <h4 className={classes.cardTitle}>
              My Contact Email Addresses (how we can reach you)
            </h4>
            <br />
          </GridItem>
          <GridItem xs={11}>
            <Table tableData={emailTableData} />
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

// export default withStyles(styles)(loadContent("user.session", AccountInfoCard));
export default withStyles(styles)(loadForm("user.session", AccountInfoCard));
